var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9897 10.735C21.8346 5.29492 17.3098 0.75 11.9596 0.75C6.65968 0.75 2.15997 5.29492 2.00997 10.735C0.815077 11.395 0 12.6751 0 14.1348V15.3649C0 17.5047 1.74501 19.2498 3.88494 19.2498H4.49993C4.7749 19.2498 4.99985 19.0249 4.99985 18.7499V10.7502C4.99985 10.4752 4.7749 10.2503 4.49993 10.2503H3.88494C3.58988 10.2503 3.29984 10.2852 3.02486 10.3453C3.37496 5.62043 7.32476 1.75045 11.9599 1.75045C16.6348 1.75045 20.6196 5.62027 20.9699 10.3453C20.695 10.2852 20.41 10.2503 20.1149 10.2503L19.5001 10.2501C19.2251 10.2501 19.0001 10.475 19.0001 10.75V18.7497C19.0001 19.0246 19.2251 19.2496 19.5001 19.2496H20V20.0197C20 20.7046 19.44 21.2645 18.7501 21.2645H14.93C14.745 20.6746 14.1901 20.2496 13.5401 20.2496H10.4602C9.65524 20.2496 9.00023 20.9047 9.00023 21.7097V21.7896C9.00023 22.5946 9.65524 23.2496 10.4602 23.2496H13.5401C14.18 23.2496 14.7252 22.8346 14.9202 22.2646H18.7501C19.9901 22.2646 21 21.2595 21 20.0197V19.1498C22.7149 18.7449 24 17.1999 24 15.3649V14.1349C24 12.6751 23.1849 11.3951 21.99 10.7351L21.9897 10.735Z",
    fill: "url(#paint0_linear_8633_15201)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8633_15201",
    x1: 23.9977,
    y1: 11.8936,
    x2: -1.24619,
    y2: 11.8936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005887"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.f9687c3602fe148d6c355170783beaf0.svg";
export { ForwardRef as ReactComponent };